module.exports = __webpack_public_path__ + "static/media/tag.8454c5f9.svg";